import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ViewHeadlineOutlinedIcon from '@mui/icons-material/ViewHeadlineOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowLeftOutlinedIcon from '@mui/icons-material/ArrowLeftOutlined';
import ArrowRightOutlinedIcon from '@mui/icons-material/ArrowRightOutlined';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CopyAllOutlinedIcon from '@mui/icons-material/CopyAllOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SwapVertOutlinedIcon from '@mui/icons-material/SwapVertOutlined';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import CircleIcon from '@mui/icons-material/Circle';
import LockIcon from '@mui/icons-material/Lock';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import VerticalAlignBottomOutlinedIcon from '@mui/icons-material/VerticalAlignBottomOutlined';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import CheckIcon from '@mui/icons-material/Check';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import {ReactComponent as UnionIcon} from '../../../assests/svg/Union.svg';
import PushPin from '@mui/icons-material/PushPin';
import PushPinOutlined from '@mui/icons-material/PushPinOutlined';
import Block from '@mui/icons-material/Block';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import WidgetsOutlined from '@mui/icons-material/WidgetsOutlined';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import PostAddOutlined from '@mui/icons-material/PostAddOutlined';
import BookmarksOutlined from '@mui/icons-material/BookmarksOutlined';
import ContentCopyOutlined from '@mui/icons-material/ContentCopyOutlined';
import SwapHorizOutlined from '@mui/icons-material/SwapHorizOutlined';
import FilterAltOutlined from '@mui/icons-material/FilterAltOutlined';
import FilterListOutlined from '@mui/icons-material/FilterListOutlined';
import Cancel from '@mui/icons-material/Cancel';
import TurnLeftIcon from '@mui/icons-material/TurnLeft';
import Email from '@mui/icons-material/Email';
import {ReactComponent as ExportIcon} from '../../../assests/svg/export.svg';
import {ReactComponent as TagIcon} from '../../../assests/svg/tags.svg';
import {ReactComponent as LoadsIcon} from '../../../assests/svg/loads.svg';
import {ReactComponent as ViewIcon} from '../../../assests/svg/view_icon.svg';
import {ReactComponent as ContactIcon} from '../../../assests/svg/contact.svg';
import {ReactComponent as DocumentIcon} from '../../../assests/svg/document.svg';
import {ReactComponent as DrawingIcon} from '../../../assests/svg/drawing.svg';
import {ReactComponent as EmailIcon} from '../../../assests/svg/email_icon.svg';
import {ReactComponent as ImageIcon} from '../../../assests/svg/image.svg';
import {ReactComponent as MultimediaIcon} from '../../../assests/svg/multimedia.svg';
import {ReactComponent as NoDataIcon} from '../../../assests/svg/noData.svg';
import {ReactComponent as OtherDocumentIcon} from '../../../assests/svg/otherDocument.svg';
import {ReactComponent as PresentationIcon} from '../../../assests/svg/presentation.svg';
import {ReactComponent as SpreadsheetIcon} from '../../../assests/svg/spreadsheet.svg';
import {ReactComponent as SystemFileIcon} from '../../../assests/svg/systemFile.svg';
import {ReactComponent as ExportGridIcon} from '../../../assests/svg/export-grid.svg';
import {ReactComponent as ClearFiltersIcon} from '../../../assests/svg/clear-fliters.svg';
import {ReactComponent as LogicIcon} from '../../../assests/svg/logic.svg';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import {ReactComponent as ScopeIcon} from '../../../assests/svg/scope_icon.svg';
import {ReactComponent as ReplaceIcon} from '../../../assests/svg/project_replace_icon.svg';
import {ReactComponent as CalendarIcon} from '../../../assests/svg/calendar_icon.svg';
import {ReactComponent as ChatIcon} from '../../../assests/svg/chat_icon.svg';
import {ReactComponent as ContainerIcon} from '../../../assests/svg/container_icon.svg';
import {ReactComponent as DatabaseIcon} from '../../../assests/svg/database_icon.svg';
import {ReactComponent as LogIcon} from '../../../assests/svg/log_icon.svg';
import {ReactComponent as LeftUpArrowIcon} from '../../../assests/svg/left-up-arrow.svg';

type IconSize = 'small' | 'medium' | 'large';
export type {IconSize};

export enum IconNames {
  Add = 'add',
  Remove = 'remove',
  Edit = 'edit',
  Home = 'home',
  Clients = 'clients',
  Users = 'users',
  Security = 'security',
  Description = 'description',
  Settings = 'settings',
  CaretUp = 'caret-up',
  CaretDown = 'caret-down',
  CaretLeft = 'caret-left',
  CaretRight = 'caret-right',
  ChevronUp = 'chevron-up',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  Key = 'key',
  Locked = 'locked',
  Unlocked = 'unlocked',
  RemoveRedEye = 'remove-red-eye',
  GridView = 'grid-view',
  ListView = 'list-view',
  Search = 'search',
  Close = 'close',
  Copy = 'copy',
  Error = 'error',
  Info = 'info',
  Sort = 'sort',
  More = 'more',
  Notifications = 'notifications',
  BarChart = 'bar-chart',
  Circle = 'circle',
  CurrencyUSD = 'currency-usd',
  Download = 'download',
  CircleEmpty = 'circle-empty',
  CurrencyUSDClose = 'currency-usd-close',
  CheckMark = 'check',
  Print = 'print',
  Union = 'union',
  OpenInNewIcon = 'open-in-new-icon',
  PushPin = 'push-pin',
  PushPinOutlined = 'push-pin-outlined',
  Block = 'block',
  GroupOutlined = 'group-outlined',
  ArrowBack = 'arrow-back',
  ArrowForward = 'arrow-forward',
  CalendarTodayOutlined = 'calendar-today-outlined',
  WidgetOutlined = 'widget-outlined',
  DragIndicator = 'drag-indicator',
  PostAddOutlined = 'post-add-utlined',
  BookmarksOutlined = 'bookmarks-outlined',
  ContentCopyOutlined = 'content-copy-outlined',
  SwapHorizOutlined = 'swap-horiz-outlined',
  Export = 'export',
  Tag = 'tag',
  Loads = 'loads',
  View = 'view',
  ContactIcon = 'ContactIcon',
  DocumentIcon = 'DocumentIcon',
  DrawingIcon = 'DrawingIcon',
  EmailIcon = 'EmailIcon',
  ImageIcon = 'ImageIcon',
  MultimediaIcon = 'MultimediaIcon',
  NoDataIcon = 'NoDataIcon',
  OtherDocumentIcon = 'OtherDocumentIcon',
  PresentationIcon = 'PresentationIcon',
  SpreadsheetIcon = 'SpreadsheetIcon',
  SystemFileIcon = 'SystemFileIcon',
  ExportGridIcon = 'ExportGridIcon',
  FilterAltOutlined = 'filter-alt-outlined',
  FilterListOutlined = 'filter-list-outlined',
  Cancel = 'cancel',
  ClearFiltersIcon = 'ClearFiltersIcon',
  CachedIcon = 'CachedIcon',
  ArrowUpwardIcon = 'ArrowUpwardIcon',
  ScopeIcon = 'ScopeIcon',
  LogicIcon = 'logicIcon',
  ReplaceIcon = 'replaceIcon',
  CalendarIcon = 'CalendarIcon',
  ChatIcon = 'ChatIcon',
  ContainerIcon = 'ContainerIcon',
  DatabaseIcon = 'DatabaseIcon',
  LogIcon = 'LogIcon',
  TurnLeftIcon = 'TurnLeftIcon',
  LeftUpArrowIcon = 'LeftUpArrowIcon',
  Email = 'Email',
}

const iconMap = [
  // Actions - CRUD
  {
    name: IconNames.Add,
    icon: (className: string, size: IconSize) => (
      <AddOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Remove,
    icon: (className: string, size: IconSize) => (
      <DeleteOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Edit,
    icon: (className: string, size: IconSize) => (
      <EditOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  // Nav
  {
    name: IconNames.Home,
    icon: (className: string, size: IconSize) => (
      <AccountBalanceOutlinedIcon className={className} fontSize={size} aria-hidden="true" focusable="false" />
    ),
  },
  {
    name: IconNames.Clients,
    icon: (className: string, size: IconSize) => (
      <FolderSharedOutlinedIcon className={className} fontSize={size} aria-hidden="true" focusable="false" />
    ),
  },
  {
    name: IconNames.Users,
    icon: (className: string, size: IconSize) => (
      <PeopleOutlinedIcon className={className} fontSize={size}  aria-hidden="true" focusable="false" />
    ),
  },
  {
    name: IconNames.Security,
    icon: (className: string, size: IconSize) => (
      <SecurityOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Settings,
    icon: (className: string, size: IconSize) => (
      <SettingsOutlinedIcon className={className} fontSize={size} aria-hidden="true"/>
    ),
  },
  // Caret
  {
    name: IconNames.CaretUp,
    icon: (className: string, size: IconSize) => (
      <ArrowDropUpOutlinedIcon className={className} fontSize={size} aria-hidden="true"/>
    ),
  },
  {
    name: IconNames.CaretDown,
    icon: (className: string, size: IconSize) => (
      <ArrowDropDownOutlinedIcon className={className} fontSize={size} aria-hidden="true"/>
    ),
  },
  {
    name: IconNames.CaretLeft,
    icon: (className: string, size: IconSize) => (
      <ArrowLeftOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.CaretRight,
    icon: (className: string, size: IconSize) => (
      <ArrowRightOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  // Chevron
  {
    name: IconNames.ChevronUp,
    icon: (className: string, size: IconSize) => (
      <ExpandLessOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ChevronDown,
    icon: (className: string, size: IconSize) => (
      <ExpandMoreOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ChevronLeft,
    icon: (className: string, size: IconSize) => (
      <ChevronLeftOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ChevronRight,
    icon: (className: string, size: IconSize) => (
      <ChevronRightOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  // Security
  {
    name: IconNames.Key,
    icon: (className: string, size: IconSize) => (
      <KeyOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Locked,
    icon: (className: string, size: IconSize) => (
      <LockIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.RemoveRedEye,
    icon: (className: string, size: IconSize) => (
      <RemoveRedEyeOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Unlocked,
    icon: (className: string, size: IconSize) => (
      <LockOpenOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  // Miscellaneous
  {
    name: IconNames.GridView,
    icon: (className: string, size: IconSize) => (
      <GridViewOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ListView,
    icon: (className: string, size: IconSize) => (
      <ViewHeadlineOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Search,
    icon: (className: string, size: IconSize) => (
      <SearchOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Description,
    icon: (className: string, size: IconSize) => (
      <DescriptionOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Close,
    icon: (className: string, size: IconSize) => (
      <CloseOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Copy,
    icon: (className: string, size: IconSize) => (
      <CopyAllOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Error,
    icon: (className: string, size: IconSize) => (
      <ErrorOutlineOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Info,
    icon: (className: string, size: IconSize) => (
      <InfoOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Sort,
    icon: (className: string, size: IconSize) => (
      <SwapVertOutlinedIcon className={className} fontSize={size} aria-hidden="true"/>
    ),
  },
  {
    name: IconNames.More,
    icon: (className: string, size: IconSize) => (
      <MoreVertOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Notifications,
    icon: (className: string, size: IconSize) => (
      <NotificationsOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.BarChart,
    icon: (className: string, size: IconSize) => (
      <LeaderboardOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Circle,
    icon: (className: string, size: IconSize) => (
      <CircleIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.CircleEmpty,
    icon: (className: string, size: IconSize) => (
      <PanoramaFishEyeIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.CurrencyUSDClose,
    icon: (className: string, size: IconSize) => (
      <MoneyOffIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.CurrencyUSD,
    icon: (className: string, size: IconSize) => (
      <AttachMoneyOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Download,
    icon: (className: string, size: IconSize) => (
      <VerticalAlignBottomOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.CheckMark,
    icon: (className: string, size: IconSize) => (
      <CheckIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.OpenInNewIcon,
    icon: (className: string, size: IconSize) => (
      <OpenInNewIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  //Print Icon
  {
    name: IconNames.Print,
    icon: (className: string, size: IconSize) => (
      <PrintOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  //Concierge Report Icon
  {
    name: IconNames.Union,
    icon: (className: string, size: IconSize) => (
      <UnionIcon
        data-testid="UnionIcon"
        className={className}
        fontSize={size}
        aria-hidden="true"
        focusable="false" 
      />
    ),
  },
  {
    name: IconNames.PushPin,
    icon: (className: string, size: IconSize) => (
      <PushPin className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.PushPinOutlined,
    icon: (className: string, size: IconSize) => (
      <PushPinOutlined className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Block,
    icon: (className: string, size: IconSize) => (
      <Block className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ArrowBack,
    icon: (className: string, size: IconSize) => (
      <ArrowBackIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.GroupOutlined,
    icon: (className: string, size: IconSize) => (
      <GroupOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ArrowForward,
    icon: (className: string, size: IconSize) => (
      <ArrowForwardIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.WidgetOutlined,
    icon: (className: string, size: IconSize) => (
      <WidgetsOutlined className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.DragIndicator,
    icon: (className: string, size: IconSize) => (
      <DragIndicatorIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.PostAddOutlined,
    icon: (className: string, size: IconSize) => (
      <PostAddOutlined className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.BookmarksOutlined,
    icon: (className: string, size: IconSize) => (
      <BookmarksOutlined className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Export,
    icon: (className: string, size: IconSize) => (
      <ExportIcon
        className={className}
        fontSize={size}
        data-testid="ExportIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.CalendarTodayOutlined,
    icon: (className: string, size: IconSize) => (
      <CalendarTodayOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Tag,
    icon: (className: string, size: IconSize) => (
      <TagIcon className={className} fontSize={size} data-testid="TagIcon" aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Loads,
    icon: (className: string, size: IconSize) => (
      <LoadsIcon className="loads-icon" fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ContentCopyOutlined,
    icon: (className: string, size: IconSize) => (
      <ContentCopyOutlined className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.View,
    icon: (className: string, size: IconSize) => (
      <ViewIcon className={className} fontSize={size} data-testid="ViewIcon" aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ContactIcon,
    icon: (className: string, size: IconSize) => (
      <ContactIcon
        className={className}
        fontSize={size}
        data-testid="ContactIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.DocumentIcon,
    icon: (className: string, size: IconSize) => (
      <DocumentIcon
        className={className}
        fontSize={size}
        data-testid="DocumentIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.DrawingIcon,
    icon: (className: string, size: IconSize) => (
      <DrawingIcon
        className={className}
        fontSize={size}
        data-testid="DrawingIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.EmailIcon,
    icon: (className: string, size: IconSize) => (
      <EmailIcon
        className={className}
        fontSize={size}
        data-testid="EmailIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.ImageIcon,
    icon: (className: string, size: IconSize) => (
      <ImageIcon
        className={className}
        fontSize={size}
        data-testid="ImageIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.MultimediaIcon,
    icon: (className: string, size: IconSize) => (
      <MultimediaIcon
        className={className}
        fontSize={size}
        data-testid="MultimediaIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.NoDataIcon,
    icon: (className: string, size: IconSize) => (
      <NoDataIcon
        className={className}
        fontSize={size}
        data-testid="NoDataIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.OtherDocumentIcon,
    icon: (className: string, size: IconSize) => (
      <OtherDocumentIcon
        className={className}
        fontSize={size}
        data-testid="OtherDocumentIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.PresentationIcon,
    icon: (className: string, size: IconSize) => (
      <PresentationIcon
        className={className}
        fontSize={size}
        data-testid="PresentationIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.SpreadsheetIcon,
    icon: (className: string, size: IconSize) => (
      <SpreadsheetIcon
        className={className}
        fontSize={size}
        data-testid="SpreadsheetIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.SystemFileIcon,
    icon: (className: string, size: IconSize) => (
      <SystemFileIcon
        className={className}
        fontSize={size}
        data-testid="SystemFileIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.SwapHorizOutlined,
    icon: (className: string, size: IconSize) => (
      <SwapHorizOutlined className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ExportGridIcon,
    icon: (className: string, size: IconSize) => (
      <ExportGridIcon
        className={className}
        fontSize={size}
        data-testid="ExportGridIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.FilterAltOutlined,
    icon: (className: string, size: IconSize) => (
      <FilterAltOutlined className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.FilterListOutlined,
    icon: (className: string, size: IconSize) => (
      <FilterListOutlined className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.Cancel,
    icon: (className: string, size: IconSize) => (
      <Cancel className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ClearFiltersIcon,
    icon: (className: string, size: IconSize) => (
      <ClearFiltersIcon
        className={className}
        fontSize={size}
        data-testid="ClearFiltersIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.CachedIcon,
    icon: (className: string, size: IconSize) => (
      <CachedOutlinedIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ArrowUpwardIcon,
    icon: (className: string, size: IconSize) => (
      <ArrowUpwardIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ScopeIcon,
    icon: (className: string, size: IconSize) => (
      <ScopeIcon
        className={className}
        fontSize={size}
        data-testid="ScopeIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.LogicIcon,
    icon: (className: string, size: IconSize) => (
      <LogicIcon
        className={className}
        fontSize={size}
        data-testid="LogicIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.ReplaceIcon,
    icon: (className: string, size: IconSize) => (
      <ReplaceIcon
        className={className}
        fontSize={size}
        data-testid="ReplaceIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.CalendarIcon,
    icon: (className: string, size: IconSize) => (
      <CalendarIcon
        className={className}
        fontSize={size}
        data-testid="CalendarIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.ChatIcon,
    icon: (className: string, size: IconSize) => (
      <ChatIcon className={className} fontSize={size} data-testid="ChatIcon" aria-hidden="true" />
    ),
  },
  {
    name: IconNames.ContainerIcon,
    icon: (className: string, size: IconSize) => (
      <ContainerIcon
        className={className}
        fontSize={size}
        data-testid="ContainerIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.DatabaseIcon,
    icon: (className: string, size: IconSize) => (
      <DatabaseIcon
        className={className}
        fontSize={size}
        data-testid="DatabaseIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.LogIcon,
    icon: (className: string, size: IconSize) => (
      <LogIcon className={className} fontSize={size} data-testid="LogIcon" aria-hidden="true" />
    ),
  },
  {
    name: IconNames.TurnLeftIcon,
    icon: (className: string, size: IconSize) => (
      <TurnLeftIcon className={className} fontSize={size} aria-hidden="true" />
    ),
  },
  {
    name: IconNames.LeftUpArrowIcon,
    icon: (className: string, size: IconSize) => (
      <LeftUpArrowIcon
        className={className}
        fontSize={size}
        data-testid="LeftUpArrowIcon"
        aria-hidden="true"
      />
    ),
  },
  {
    name: IconNames.Email,
    icon: (className: string, size: IconSize) => (
      <Email className={className} fontSize={size} aria-hidden="true" />
    ),
  },
];

export enum IconColors {
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Warning = 'warning',
  Critical = 'critical',
  Custom = 'custom',
}

type AurIconProps = {
  icon: IconNames;
  color?: IconColors;
  size?: IconSize;
  customClassName?: string;
};

const AurIcon = (props: AurIconProps) => {
  const colorMap = [
    {name: IconColors.Primary, className: 'icon-primary'},
    {name: IconColors.Secondary, className: 'icon-secondary'},
    {name: IconColors.Success, className: 'icon-success'},
    {name: IconColors.Warning, className: 'icon-warning'},
    {name: IconColors.Critical, className: 'icon-critical'},
    {name: IconColors.Custom, className: `${props.customClassName}`},
  ];

  // Get the icon
  const iconMapping = iconMap.find((i) => i.name === props.icon);
  const iconFunction = iconMapping?.icon;
  if (!iconFunction) {
    return <></>;
  }

  // Get the icon color
  // Default is "primary"
  const color = props.color ?? IconColors.Primary;
  const colorMapping = colorMap.find((i) => i.name === color);
  const colorClassName = colorMapping?.className ?? 'icon-primary';

  // Get the icon size
  // Default is "medium"
  const size = props.size ?? 'medium';

  return iconFunction(colorClassName, size);
};

export default AurIcon;
